import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index/Index'
import WxShopDemo from '@/components/Index/WxShopDemo'
import Demo from '@/components/Index/Demo'
import IndexXywl from '@/components/Index/IndexXywl'
// import IndexXywlNew from '@/components/Index/IndexXywlNew'
import IndexZtHpzg from '@/components/Index/IndexZtHpzg'
import IndexSxJcty from '@/components/Index/IndexSxJcty'
import IndexLjyx from '@/components/Index/IndexLjyx'
import IndexJfty from '@/components/Index/IndexJfty'
import IndexBrq from '@/components/Index/IndexBrq'
import IndexXrxk from '@/components/Index/IndexXrxk'
import IndexRcqqx from '@/components/Index/IndexRcqqx'
import XmIndex from '@/components/XmIndex/XmIndex'
import WriteTeamRym from '@/components/WriteTeamRym/WriteTeamRym'
import LingDuiReport from '@/components/ReportXm/LingDuiReport'
import GrBmDataIndex from '@/components/ReportXm/GrBmDataIndex'
import ReportXm from '@/components/ReportXm/ReportXm'
import AddRyInfo from '@/components/ReportXm/AddRyInfo'
import DyGl from '@/components/ReportXm/DyGl'
import TeamAddDy from '@/components/ReportXm/TeamAddDy'
import TeamSelectCy from '@/components/ReportXm/TeamSelectCy'
import SsbfIndex from '@/components/SsbfIndex/SsbfIndex'
import CjcIndex from '@/components/CjcIndex/CjcIndex'
import CjpmIndex from '@/components/CjpmIndex/CjpmIndex'
import ZxcIndex from '@/components/ZxcIndex/ZxcIndex'
import ChangeXmIndex from '@/components/ChangeXmIndex/ChangeXmIndex'
import GetOpenId from '@/components/GetOpenId/GetOpenId'
import MeIndex from '@/components/MeIndex/MeIndex'
import MeBsIndex from '@/components/MeIndex/MeBsIndex'
import ConnectMe from '@/components/MeIndex/ConnectMe'
import AddPlayer from '@/components/MeIndex/AddPlayer'
import EventStatistics from '@/components/MeIndex/EventStatistics'
import MemberBenefits from '@/components/MeIndex/MemberBenefits'

import LoginIndex from '@/components/LoginIndex/LoginIndex'
import RegisterIndex from '@/components/LoginIndex/RegisterIndex'
import SsbfMxIndex from '@/components/SsbfIndex/SsbfMxIndex'
import SsgcIndex from '@/components/SsgcIndex/SsgcIndex'
import SsznIndex from '@/components/SsznIndex/SsznIndex'
import CqGsIndex from '@/components/RyGsIndex/CqGsIndex'
import MdGsIndex from '@/components/RyGsIndex/MdGsIndex'
import JmdIndex from '@/components/JmdIndex/JmdIndex'
import SuccessIndex from '@/components/ReportXm/SuccessIndex'
import PayIndex from '@/components/ReportXm/PayIndex'
import AlreadyBmxx from '@/components/ReportXm/AlreadyBmxx'
import TeamRyItemBm from '@/components/ReportXm/TeamRyItemBm'
import MeNewIndex from '@/components/MeIndex/MeNewIndex'
import QqYlmJfIndex from '@/components/MeIndex/QqYlmJfIndex'
import MeQygjIndex from '@/components/MeIndex/MeQygjIndex'
import OutPageIndex from '@/components/OutPageIndex/OutPageIndex'
import Test from '@/components/Test/Test'
import TxzIndex from '@/components/TxzIndex/TxzIndex'
import ProjectListIndex from '@/components/ProjectListIndex/ProjectListIndex'
import IndexGxss from '@/components/Index/IndexGxss'
import AdIndex from '@/components/AdIndex/AdIndex'
import CcmdCodeIndex from '@/components/CcmdCodeIndex/CcmdCodeIndex'
import QdGlIndex from '@/components/qdGlIndex/QdGlIndex'
import CertGlIndex from '@/components/CertGlIndex/CertGlIndex'

Vue.use(Router) 



const router = new Router({
  base:'/wap/',//   
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '首页',
        keepAlive: true
      }
    },
    {
      path: '/indexXywl',
      name: 'IndexXywl',
      component: IndexXywl,
      meta: {
        title: '星耀未来系列赛事',
        keepAlive: false
      }
    },
    {
      path: '/xmIndex',
      name: 'XmIndex',
      component: XmIndex,
      meta: {
        title: '赛事详情',
        keepAlive: false
      }
    },
    {
      path: '/lingDuiReport',
      name: 'LingDuiReport',
      component: LingDuiReport,
      meta: {
        title: '领队报名',
        keepAlive: false
      }
    },
    {
      path: '/grBmDataIndex',
      name: 'GrBmDataIndex',
      component: GrBmDataIndex,
      meta: {
        title: '个人报名信息',
        keepAlive: false
      }
    },
    {
      path: '/dyGl',
      name: 'DyGl',
      component: DyGl,
      meta: {
        title: '队员管理',
        keepAlive: false
      }
    }
    ,
    {
      path: '/teamAddDy',
      name: 'TeamAddDy',
      component: TeamAddDy,
      meta: {
        title: '已有队员',
        keepAlive: false
      }
    },
    {
      path: '/addRyInfo',
      name: 'AddRyInfo',
      component: AddRyInfo,
      meta: {
        title: '信息填写',
        keepAlive: false
      }
    },
    {
      path: '/teamSelectCy',
      name: 'TeamSelectCy',
      component: TeamSelectCy,
      meta: {
        title: '填写成员',
        keepAlive: false
      }
    },
    {
      path: '/reportXm',
      name: 'ReportXm',
      component: ReportXm,
      meta: {
        title: '项目报名',
        keepAlive: false
      }
    },
    {
      path: '/writeTeamRym',
      name: 'WriteTeamRym',
      component: WriteTeamRym,
      meta: {
        title: '填写出场名单',
        keepAlive: false
      }
    },
    {
      path: '/zxcIndex',
      name: 'ZxcIndex',
      component: ZxcIndex,
      meta: {
        title: '秩序册',
        keepAlive: true
      }
    },
    {
      path: '/cjpmIndex',
      name: 'CjpmIndex',
      component: CjpmIndex,
      meta: {
        title: '成绩排名',
        keepAlive: true
      }
    },
    {
      path: '/cjcIndex',
      name: 'CjcIndex',
      component: CjcIndex,
      meta: {
        title: '成绩册',
        keepAlive: true
      }
    },
    {
      path: '/ssbfIndex',
      name: 'SsbfIndex',
      component: SsbfIndex,
      meta: {
        title: '实时比分',
        keepAlive: false
      }
    },
    {
      path: '/changeXmIndex',
      name: 'ChangeXmIndex',
      component: ChangeXmIndex,
      meta: {
        title: '选择项目',
        keepAlive: true
      }
    },
    {
      path: '/getOpenId',
      name: 'GetOpenId',
      component: GetOpenId,
      meta: {
        title: '获取数据',
        keepAlive: false
      }
    },
    {
      path: '/meIndex',
      name: 'MeIndex',
      component: MeIndex,
      meta: {
        title: '个人中心',
        keepAlive: false
      }
    },
    {
      path: '/loginIndex',
      name: 'LoginIndex',
      component: LoginIndex,
      meta: {
        title: '跑兔体育',
        keepAlive: false
      }
    },
    {
      path: '/registerIndex',
      name: 'RegisterIndex',
      component: RegisterIndex,
      meta: {
        title: '用户注册',
        keepAlive: false
      }
    },
    {
      path: '/ssbfMxIndex',
      name: 'SsbfMxIndex',
      component: SsbfMxIndex,
      meta: {
        title: '单场比分',
        keepAlive: false
      }
    },
    {
      path: '/meBsIndex',
      name: 'MeBsIndex',
      component: MeBsIndex,
      meta: {
        title: '我的比赛',
        keepAlive: false
      }
    },
    {
      path: '/ssgcIndex',
      name: 'SsgcIndex',
      component: SsgcIndex,
      meta: {
        title: '赛事规程',
        keepAlive: false
      }
    },
    {
      path: '/mdGsIndex',
      name: 'MdGsIndex',
      component: MdGsIndex,
      meta: {
        title: '名单公示',
        keepAlive: false
      }
    },
    {
      path: '/cqGsIndex',
      name: 'CqGsIndex',
      component: CqGsIndex,
      meta: {
        title: '抽签公示',
        keepAlive: false
      }
    },
    {
      path: '/jmdIndex',
      name: 'JmdIndex',
      component: JmdIndex,
      meta: {
        title: '节目单',
        keepAlive: true
      }
    },
    {
      path: '/connectMe',
      name: 'ConnectMe',
      component: ConnectMe,
      meta: {
        title: '联系我们',
        keepAlive: false
      }
    },
    {
      path: '/successIndex',
      name: 'SuccessIndex',
      component: SuccessIndex,
      meta: {
        title: '处理成功',
        keepAlive: false
      }
    },
    {
      path: '/ssznIndex',
      name: 'SsznIndex',
      component: SsznIndex,
      meta: {
        title: '赛事规程',
        keepAlive: false
      }
    },
    {
      path: '/payIndex',
      name: 'PayIndex',
      component: PayIndex,
      meta: {
        title: '在线支付',
        keepAlive: false
      }
    },
    {
      path: '/alreadyBmxx',
      name: 'AlreadyBmxx',
      component: AlreadyBmxx,
      meta: {
        title: '已报名信息',
        keepAlive: false
      }
    },
    {
      path: '/teamRyItemBm',
      name: 'TeamRyItemBm',
      component: TeamRyItemBm,
      meta: {
        title: '队员报名系统',
        keepAlive: false
      }
    },
    {
      path: '/meNewIndex',
      name: 'MeNewIndex',
      component: MeNewIndex,
      meta: {
        title: '我的生涯',
        keepAlive: false
      }
    },
    {
      path: '/indexZtHpzg',
      name: 'IndexZtHpzg',
      component: IndexZtHpzg,
      meta: {
        title: '挥拍中国',
        keepAlive: false
      }
    },
    {
      path: '/indexSxJcty',
      name: 'IndexSxJcty',
      component: IndexSxJcty,
      meta: {
        title: '俊才体育',
        keepAlive: false
      }
    },
    {
      path: '/indexJfty',
      name: 'IndexJfty',
      component: IndexJfty,
      meta: {
        title: '金风体育',
        keepAlive: false
      }
    },
    {
      path: '/indexBrq',
      name: 'IndexBrq',
      component: IndexBrq,
      meta: {
        title: '必锐奇体育',
        keepAlive: false
      }
    },
    {
      path: '/indexXrxk',
      name: 'IndexXrxk',
      component: IndexXrxk,
      meta: {
        title: '旭日星空',
        keepAlive: false
      }
    },
    {
      path: '/indexRcqqx',
      name: 'IndexRcqqx',
      component: IndexRcqqx,
      meta: {
        title: '羽球星体育',
        keepAlive: false
      }
    },{
      path: '/meQygjIndex',
      name: 'MeQygjIndex',
      component: MeQygjIndex,
      meta: {
        title: '成长轨迹',
        keepAlive: false
      }
    },{
      path: '/demo',
      name: 'Demo',
      component: Demo,
      meta: {
        title: '测试',
        keepAlive: false
      }
    },{
      path: '/outPageIndex',
      name: 'OutPageIndex',
      component: OutPageIndex,
      meta: {
        title: '正在直播',
        keepAlive: false
      }
    },{
      path: '/wxShopDemo',
      name: 'WxShopDemo',
      component: WxShopDemo,
      meta: {
        title: '正在直播',
        keepAlive: false
      }
    },{
      path: '/addPlayer',
      name: 'AddPlayer',
      component: AddPlayer,
      meta: {
        title: '绑定球员',
        keepAlive: false
      }
    },{
      path: '/eventStatistics',
      name: 'EventStatistics',
      component: EventStatistics,
      meta: {
        title: '赛事统计',
        keepAlive: false
      }
    },{
      path: '/memberBenefits',
      name: 'MemberBenefits',
      component: MemberBenefits,
      meta: {
        title: '会员权益',
        keepAlive: false
      }
    },{
      path: '/test',
      name: 'Test',
      component: Test,
      meta: {
        title: '测试',
        keepAlive: false
      }
    },{
      path: '/txzIndex',
      name: 'TxzIndex',
      component: TxzIndex,
      meta: {
        title: '挥拍中国通行证',
        keepAlive: false
      }
    },{
      path: '/projectListIndex',
      name: 'ProjectListIndex',
      component: ProjectListIndex,
      meta: {
        title: '选择项目',
        keepAlive: false
      }
    },{
      path: '/indexGxss',
      name: 'IndexGxss',
      component: IndexGxss,
      meta: {
        title: '泱霈体育',
        keepAlive: false
      }
    },{
      path: '/indexLjyx',
      name: 'IndexLjyx',
      component: IndexLjyx,
      meta: {
        title: '辽宁优羽',
        keepAlive: false
      }
    },{
      path: '/qqYlmJfIndex',
      name: 'QqYlmJfIndex',
      component: QqYlmJfIndex,
      meta: {
        title: '积分榜单',
        keepAlive: false
      }
    },{
      path: '/adIndex',
      name: 'AdIndex',
      component: AdIndex,
      meta: {
        title: '优惠活动',
        keepAlive: false
      }
    },{
      path: '/ccmdCodeIndex',
      name: 'CcmdCodeIndex',
      component: CcmdCodeIndex,
      meta: {
        title: '出场名单填写二维码',
        keepAlive: false
      }
    },{
      path: '/qdGlIndex',
      name: 'QdGlIndex',
      component: QdGlIndex,
      meta: {
        title: '签到管理',
        keepAlive: false
      }
    },{
      path: '/certGlIndex',
      name: 'CertGlIndex',
      component: CertGlIndex,
      meta: {
        title: '荣誉证书查询',
        keepAlive: false
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js